import apiClient from './apiClient';

export interface AdminUser {
  id: string;
  email: string;
  full_name?: string;
  name?: string;
  role: string;
  tenant_id?: string;
  is_active?: boolean;
  is_verified?: boolean;
  phone?: string;
  address?: string;
}

export interface ImpersonationResponse {
  access_token: string;
  user: AdminUser;
}

export interface AdminUserCreateInput {
  email: string;
  full_name: string;
  role: string;
  password: string;
  phone?: string;
  address?: string;
  is_active?: boolean;
  is_verified?: boolean;
}

export interface AdminUserUpdateInput {
  full_name?: string;
  role?: string;
  phone?: string;
  address?: string;
  is_active?: boolean;
  is_verified?: boolean;
  password?: string;
}

export const listUsers = async (role?: string): Promise<AdminUser[]> => {
  const response = await apiClient.get('/admin/users', {
    params: role ? { role } : undefined,
  });
  return response.data;
};

export const createAdminUser = async (payload: AdminUserCreateInput): Promise<AdminUser> => {
  const response = await apiClient.post('/admin/users', payload);
  return response.data;
};

export const updateAdminUser = async (userId: string, payload: AdminUserUpdateInput): Promise<AdminUser> => {
  const response = await apiClient.put(`/admin/users/${userId}`, payload);
  return response.data;
};

export const updateUserRole = async (userId: string, newRole: string): Promise<void> => {
  await apiClient.post(`/admin/users/${userId}/role`, null, { params: { new_role: newRole } });
};

export const deactivateAdminUser = async (userId: string): Promise<void> => {
  await apiClient.post(`/admin/users/${userId}/deactivate`);
};

export const reactivateAdminUser = async (userId: string): Promise<void> => {
  await apiClient.post(`/admin/users/${userId}/reactivate`);
};

export const deleteAdminUser = async (userId: string): Promise<void> => {
  await apiClient.delete(`/admin/users/${userId}`);
};

export const impersonateUser = async (userId: string): Promise<ImpersonationResponse> => {
  const response = await apiClient.post(`/admin/users/${userId}/impersonate`);
  return response.data;
};
